import Cookies from 'js-cookie';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { HttpClient } from 'shared/libs/http';
import { AsyncState } from 'shared/libs/state';
import { SimpleResumeResponseDto } from './types';
export class SimpleResumeEditStore {
   readonly loadReuseState = new AsyncState<SimpleResumeResponseDto>();
   readonly saveRusumeState = new AsyncState<any>();
   simpleResume: SimpleResumeResponseDto['response']['simpleCv'] | null = null;
   user: SimpleResumeResponseDto['response']['userdetail'] | null = null;
   categories: SimpleResumeResponseDto['response']['categories'] = [];
   subcategories: SimpleResumeResponseDto['response']['subcategories'] = [];

   position: string = '';
   info: string = '';
   status: boolean = false;

   constructor() {
      makeObservable(this, {
         simpleResume: observable,
         user: observable,
         categories: observable,
         subcategories: observable,
         position: observable,
         info: observable,
         status: observable,
         setPosition: action.bound,
         setInfo: action.bound,
         setStatus: action.bound,
         loadingResume: computed,
         saveProcessing: computed,
         selectedCategoryName: computed,
         selectedSubcategoryName: computed,
      });
   }

   setPosition(p: string): void {
      this.position = p;
   }

   setInfo(i: string): void {
      this.info = i;
   }

   setStatus(s: boolean): void {
      this.status = s;
   }

   get loadingResume() {
      return this.loadReuseState.status === 'pending';
   }

   get saveProcessing() {
      return this.saveRusumeState.status === 'pending';
   }

   get selectedCategoryName(): string {
      if (!this.simpleResume) return '';
      return this.categories.find((item) => item.id === this.simpleResume?.category_id)?.name ?? '';
   }

   get selectedSubcategoryName(): string {
      if (!this.simpleResume?.subcategory_id) return '';
      return (
         this.subcategories.find(
            (item) => String(item.id) === String(this.simpleResume?.subcategory_id)
         )?.name ?? ''
      );
   }

   async loadResume(dto: { id: number | string }): Promise<void> {
      const tokenKey = Cookies.get('token');
      const adminID = Cookies.get('adminID');

      await this.loadReuseState.run(
         async () =>
            HttpClient.get(
               `/admin/simple_resumes/edit/${dto.id}`,

               {
                  headers: {
                     adminid: adminID,
                     Authorization: `Bearer ${tokenKey}`,
                  },
               }
            ),
         {
            onSuccess: (res) => {
               if (res.status === 200) {
                  runInAction(() => {
                     this.simpleResume = res.response.simpleCv;
                     this.user = res.response.userdetail;
                     this.categories = res.response.categories ?? [];
                     this.subcategories = res.response.subcategories ?? [];
                     this.position = res.response.simpleCv.position;
                     this.info = res.response.simpleCv.info ?? '';
                     this.status = res.response.simpleCv.is_active === 1;
                  });
               }
            },
            onError: () => {},
         }
      );
   }

   async save(
      dto: { id: number | string },
      options: { onSuccess?: (resp: any) => void; onError?: (message: string) => void }
   ): Promise<void> {
      const tokenKey = Cookies.get('token');
      const adminID = Cookies.get('adminID');

      await this.saveRusumeState.run(
         async () =>
            HttpClient.post(
               `/admin/simple_resumes/save/${dto.id}`,
               {
                  position: this.position,
                  info: this.info,
                  is_active: this.status ? 1 : 0,
               },
               {
                  headers: {
                     adminid: adminID,
                     Authorization: `Bearer ${tokenKey}`,
                  },
               }
            ),
         {
            onSuccess: (res) => {
               if (res.status === 200) {
                  options?.onSuccess?.(res);
               }
            },
            onError: (e) => {
               options?.onError?.(e.message);
            },
         }
      );
   }
}
